import React from "react";

import CalendarIcon from "@uui/Calendar";

import TableCell from "@app/analytics/components/Table/TableCell";
import TableRow from "@app/analytics/components/Table/TableRow";

import {
  EmptyStateContainer,
  EmptyStateIcon,
  EmptyStateSubtext,
  EmptyStateTitle,
} from "@rui/EmptyStateContainer";

const UpcomingEventsTableEmptyState = () => {
  return (
    <TableRow>
      <TableCell colSpan={100}>
        <EmptyStateContainer sx={{ height: "200px" }}>
          <EmptyStateIcon Icon={CalendarIcon} />
          <EmptyStateTitle>No meetings</EmptyStateTitle>
          <EmptyStateSubtext>
            There are no upcoming meetings to display.
          </EmptyStateSubtext>
        </EmptyStateContainer>
      </TableCell>
    </TableRow>
  );
};

export default UpcomingEventsTableEmptyState;
